export default __webpack_public_path__ + "static/media/02e71d3e-3124-4f91-a161-978f5f30ccef.8e3c0e66.JPG";